import React, { useEffect, useState } from "react";
import ContentCard from "./ContentCard";
import { getContentInfoBySubjectId, deleteSubject, modifyMoreInfoFlag } from "../../../services/SolutionDetailAPI";
import { Button } from "@chakra-ui/react";
import { useSetRecoilState } from "recoil";
import { SOLUTION_SUBJECT_ID, IS_MODIFY_MODE, CONTENT_TYPE, CURRENT_CONTENT } from "../../../recoilState/Atoms";

const SubjectCard = (props) => {
    let [contentCards, setContentCards] = useState([]);
    let [contentList, setContentList] = useState([]);
    let [subjectName, setSubjectName] = useState();
    let setSubjectId = useSetRecoilState(SOLUTION_SUBJECT_ID);
    let setIdModifyMode = useSetRecoilState(IS_MODIFY_MODE);
    let setContentType = useSetRecoilState(CONTENT_TYPE);
    let setCurrentContent = useSetRecoilState(CURRENT_CONTENT);

    let confirmDelete = () => {
        if (window.confirm(subjectName + "를 정말로 삭제하시겠습니까??")) {
            deleteSubject(props.subjectID).then((res) => {
                if (res && res.status === 200) {
                    alert("삭제가 완료되었습니다.");
                    props.setUpdateState(Math.random());
                }
            });
        }
    };

    useEffect(() => {
        getContentInfoBySubjectId(props.subjectID).then((res) => {
            setContentList(res.contentList);
            setSubjectName(res.subject);
        });
    }, [props.updateState]);

    useEffect(() => {
        let cards = [];
        contentList.map((content) => {
            cards.push(
                <ContentCard
                    key={content["contentID"]}
                    content={content["content"]}
                    id={content["contentID"]}
                    type={content["type"]}
                    updateState={props.updateState}
                    setUpdateState={props.setUpdateState}
                    setIsContentAddModalOpen={props.setIsContentAddModalOpen}
                    setIsSubjectModalOpen={props.setIsSubjectModalOpen}
                />
            );
        });
        setContentCards(cards);
    }, [contentList]);

    const handleOnClick = () => {
        window.location.href = `/admin/subject-detail?id=${props.subjectID}`;
    };

    return (
        <>
            <div className="justify-center items-center" style={{ width: "80%", border: "1px solid gray" }}>
                <Button fontSize="xl" size="md" colorScheme="red" mr={3} onClick={() => confirmDelete()}>
                    구성요소 삭제
                </Button>
                <Button
                    fontSize="xl"
                    size="md"
                    colorScheme="green"
                    mr={3}
                    onClick={() => {
                        setSubjectId(props.subjectID);
                        props.setIsContentAddModalOpen(true);
                        setIdModifyMode(false);
                        setContentType("text");
                    }}
                >
                    컨텐츠 추가
                </Button>
            </div>
            <div className="justify-center items-center mb-10" style={{ width: "80%", border: "1px solid gray" }}>
                <div
                    style={{
                        fontSize: "large",
                        fontWeight: "bold",
                        borderBottom: "2px solid #4f71be",
                        marginBottom: "10px",
                    }}
                >
                    {subjectName}{" "}
                    <Button
                        fontSize="xl"
                        size="md"
                        colorScheme="blue"
                        mr={3}
                        onClick={() => {
                            setSubjectId(props.subjectID);
                            setCurrentContent(subjectName);
                            props.setIsSubjectModalOpen(true);
                        }}
                    >
                        구성요소명 수정
                    </Button>
                    <Button
                        fontSize="xl"
                        size="md"
                        colorScheme={props.moreInfoFlag?"red":"green"}
                        mr={3}
                        onClick={() => {
                            modifyMoreInfoFlag(props.subjectID).then(()=>{
                                props.setUpdateState(Math.random());
                            });
                        }}
                    >
                        {props.moreInfoFlag?"상세보기 비활성화":"상세보기 활성화"}
                    </Button>

                    <Button
                        fontSize="xl"
                        size="md"
                        colorScheme="green"
                        ml={3}
                        mb={1}
                        onClick={() => handleOnClick()}
                    >
                        상세정보 더보기
                    </Button>


                </div>

                {contentCards}
            </div>
        </>
    );
};
export default SubjectCard;
